import { useLang } from "@/lib/lang";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import DocumentCard from "@/components/DocumentCard";

export default function LibraryPickerDialog({
  open,
  onOpenChange,
  documents = [],
  excludeIds = [],
  onSelect,
}) {
  const { t } = useLang();
  const excluded = new Set(excludeIds);
  const available = documents.filter((d) => !excluded.has(d.id));

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="rounded-none max-w-md grid-border p-0 gap-0 max-h-[80vh] flex flex-col">
        <DialogHeader className="grid-border-b px-5 py-4 shrink-0">
          <DialogTitle className="font-serif-display text-lg">{t("case_select_docs")}</DialogTitle>
        </DialogHeader>
        <div className="flex-1 overflow-y-auto">
          {available.length === 0 ? (
            <div className="p-8 text-center text-xs text-slate-500">{t("docs_empty_title")}</div>
          ) : (
            available.map((doc) => (
              <DocumentCard
                key={doc.id}
                doc={doc}
                onSelect={() => onSelect?.(doc.id)}
              />
            ))
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
